import { GraphQLClient } from "graphql-request";

const token = localStorage.getItem("@token");

const api = import.meta.env.VITE_API_URL;

export const graphClient = new GraphQLClient(api, {
  ...(token && {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }),
});
